import { createContext } from '@direct-frontend/modules-context';

import type { ModuleStore } from './types';

type Context = Map<
    string,
    {
        store: ModuleStore;
    }
>;

const { getContext } = createContext<Context>({
    name: '@direct-frontend/modules-store/storeManager',
    getInitialValue: () => new Map(),
});

/**
 * StoreManager, хранящий все сторы созданные модулями.
 *
 * ВНУТРЕННИЙ ЭКСПОРТ. ИСПОЛЬЗОВАТЬ В КОДЕ МОДУЛЕЙ ЗАПРЕЩЕНО.
 */
export const storeManager = {
    getStore(key: string) {
        return getContext().get(key)?.store;
    },
    getAllStores() {
        return Array.from(getContext().entries()).reduce<Record<string, ModuleStore>>((acc, [key, value]) => {
            const store = value.store;

            if (store) {
                acc[key] = store;
            }

            return acc;
        }, {});
    },
    hasStore(key: string) {
        try {
            return Boolean(getContext().get(key)?.store);
        } catch {
            return false;
        }
    },
    setStore(key: string, store: ModuleStore) {
        return getContext().set(key, {
            store,
        });
    },
    clear() {
        getContext().clear();
    },
};
